import React from 'react'
import UploaderAlert from '../../../components/Project/Dashboard/UploaderAlert'
import { Breadcrumb, Card, Col, Layout, Row, Tabs } from 'antd'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { strVal } from '../../../modules/Utils'
import { get } from 'lodash'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import HeaderCardDetails from '../../../components/Project/Dashboard/HeaderCardDetails'
import VehiclesCont from '../../../components/Project/Resources/Vehicles/VehiclesCont'
import DriversCont from '../../../components/Project/Resources/Drivers/DriversCont'
import VendorsCont from '../../../components/Project/Resources/Vendors/VendorsCont'
import FuelTokensCont from '../../../components/Project/Resources/FuelTokens/FuelTokensCont'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import OrdersCont from '../../../components/Sales/Orders/OrdersCont'
import ClientBudgetsCont from '../../../components/Project/Resources/ClientBudgets/ClientBudgetsCont'
import DepartmentsCont from '../../../components/Project/Resources/Departments/DepartmentsCont'
import InServiceCont from '../../../components/Project/Resources/InService/InServiceCont'

const { TabPane } = Tabs

const { Content } = Layout
const DocumentsWithLoading = compose(withLoadingSection)(DocumentsCont)
const topColResponsiveProps = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 24,
  xl: 6,
}

function Dashboard (props) {
  const { fetchMember, project, fetching, fetch, fetchingMember, fetchTemplate, program, teamMembers, template } = props
  const _key = props.match.params.key
  const projectId = props.match.params.projectId
  let alreadyUploadedDocument = get(project, 'project.document')
  let templateNew = []
  if (alreadyUploadedDocument) {
    let forDeletion = alreadyUploadedDocument.map((aud) => template.findIndex((t) => t.label === aud.label))
    templateNew = template.filter((t, i) => !forDeletion.includes(i))
  }
  const EnhancedOrders = withLoadingSection(OrdersCont)
  return (
    <Content>
      <Card loading={fetching}>
        <Row gutter={24}>
          <Col {...topColResponsiveProps} xl={15}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/programs/list/">Programs</Breadcrumb.Item>
              <Breadcrumb.Item
                href={`#/programs/${strVal(project, 'parent').replace('projects/', '')}/view#project-list`}>
                Parent
              </Breadcrumb.Item>
              <Breadcrumb.Item>{strVal(project, 'project.title')}</Breadcrumb.Item>
            </Breadcrumb>
            <HeaderCardDetails projectId={projectId} program={program} owner={project} _key={_key}/>
          </Col>
          <RefreshButton onClick={fetch}/>

          {templateNew.length > 0 && (
            <Col {...topColResponsiveProps} xl={9}>
              <UploaderAlert {...props} />
            </Col>
          )}
        </Row>
      </Card>
      <Card loading={fetching}>
        <Row gutter={24}>
          <Tabs
            defaultActiveKey={get(props, 'location.hash') || '#details'}
            onChange={(key) => props.history.push(key)}>
            <TabPane tab="Details" key="#details">
              {/*<Col {...topColResponsiveProps} xl={{span: 9, offset: 1}}>*/}
              {/*<Row>*/}
              {/*<Col {...topColResponsiveProps} xl={24}>*/}
              {/*<TeamWidgetCont*/}
              {/*members={teamMembers}*/}
              {/*fetch={fetchMember}*/}
              {/*loading={fetchingMember}*/}
              {/*group={get(project, 'project.group')}*/}
              {/*/>*/}
              {/*</Col>*/}
              {/*</Row>*/}
              {/*</Col>*/}
              <Col {...topColResponsiveProps} xl={24}>
                <Row>
                  <Col {...topColResponsiveProps} xl={24}>
                    <DocumentsWithLoading
                      loading={fetching}
                      fetch={fetchTemplate}
                      owner={project}
                      category={false}
                      upload={!!projectId}
                      isWidget={true}
                    />
                  </Col>
                </Row>
                <Row gutter={24}/>
              </Col>
            </TabPane>
            <TabPane tab="Orders" key="#orders">
              <OrdersCont contract={get(project, 'project.salesContract')}/>
            </TabPane>
            <TabPane tab="In Service" key="#in-services">
              <InServiceCont project={project}/>
            </TabPane>
            <TabPane tab="Vehicles" key="#vehicles">
              <VehiclesCont project={project}/>
            </TabPane>
            <TabPane tab="Drivers" key="#drivers">
              <DriversCont project={project}/>
            </TabPane>
            <TabPane tab="Vendors" key="#vendors">
              <VendorsCont project={project}/>
            </TabPane>
            <TabPane tab="Departments" key="#departments">
              <DepartmentsCont project={project}/>
            </TabPane>
            <TabPane tab="Fuel Tokens" key="#fuelTokens">
              <FuelTokensCont project={project}/>
            </TabPane>
            <TabPane tab="Client Budget Lines" key="#client-budget">
              <ClientBudgetsCont project={project}/>
            </TabPane>
          </Tabs>
        </Row>
      </Card>
    </Content>
  )
}

export default compose(withRouter)(Dashboard)
